export const fallbackLanguageCode = 'en';

export const normalizeLanguageCode = (value?: string): string => {
    const languageCode = value?.trim().toLowerCase();
    return languageCode && languageCode !== 'undefined' && languageCode !== 'null' ? languageCode : fallbackLanguageCode;
};

export default class Language {
    public languageCode: string = fallbackLanguageCode;
    public knowledgeModelAlias: string = '';
    public knowledgeModelName: string = '';
    public instrumentAlias?: string = '';
    public section?: string;
    public reportAlias?: string;

    constructor(obj?: Partial<Language>) {
        if (obj) {
            Object.assign(this, obj);
        }
        this.languageCode = normalizeLanguageCode(this.languageCode);
    }

    public get key() {
        return `${this.languageCode}_${this.knowledgeModelAlias}_${this.instrumentAlias}_${this.section ? this.section : 'empty-section'}_${
            this.reportAlias ? this.reportAlias : 'empty_report_alias'
        }`;
    }
}
